import cn from 'classnames';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export const SummaryStat = ({
  label,
  value,
  children,
  title,
  tooltip,
  truncate = false,
  className,
  breakdown,
  breakdownIcon,
  dataTestId,
}) => {
  const hasBreakdown = Array.isArray(breakdown) && breakdown.length > 0;
  const titleAttr = tooltip ?? title;

  const displayValue = hasBreakdown ? null : (children ?? value);

  return (
    <div className={className} data-testid={dataTestId}>
      <p className="text-lg text-text-tertiary uppercase tracking-wide font-medium mb-1">{label}</p>
      {hasBreakdown ? (
        <div
          className="flex flex-wrap items-center gap-x-3 gap-y-1 text-2xl font-medium"
          title={titleAttr}>
          {(breakdown || []).map((item, index) => (
            <OverlayTrigger
              key={index}
              trigger={item.tooltip ? ['hover', 'focus'] : 'none'}
              placement="bottom"
              overlay={<Tooltip>{item.tooltip}</Tooltip>}>
              <span
                className={cn('inline-flex items-center gap-1', item.className)}
                title={item.tooltip}>
                {item.count}
                {item.icon ?? breakdownIcon}
              </span>
            </OverlayTrigger>
          ))}
        </div>
      ) : (
        <p
          className={cn('text-2xl font-medium text-neutral-7', truncate && 'truncate')}
          title={titleAttr}>
          {displayValue}
        </p>
      )}
    </div>
  );
};
